export default "__VITE_ASSET__D$n2k67H__"